'use client';

import { useEffect } from 'react';

/**
 * Client-only utility component that dynamically injects non-critical external stylesheets.
 *
 * Postpones loading heavy third-party CSS (such as Slick Carousel styles) until after
 * initial page hydration completes, reducing render-blocking resources and improving
 * Core Web Vitals (First Contentful Paint and Largest Contentful Paint).
 *
 * @returns `null` as this component performs purely programmatic DOM manipulation
 */
export function DeferredStyle() {
  useEffect(() => {
    // Load non-critical CSS after hydration
    const styles = [
      'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css',
    ];

    styles.forEach((href) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    });
  }, []);

  return null;
}